import IndexedDBServiceBase from "core/services/indexedDB/indexedDB-service";

class TablesIndexedDBService extends IndexedDBServiceBase {
    constructor() {
        super({
            database: "table-selection",
            database_version: 1,
            objectStore: "store",
            keyPath: "id"
        });
    }
}

const tablesIndexedDB = new TablesIndexedDBService();
export default tablesIndexedDB;
